import Navbar from "../components/Navbar";
import PortfolioGrid from "../components/PortfolioGrid";
import GetInTouch from "../components/GetInTouch";
import Footer from "../components/Footer";
import { useEffect } from "react";

function PortfolioPage({ openModal }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar openModal={openModal} />
      <PortfolioGrid />
      <GetInTouch />
      <Footer />
    </>
  );
}

export default PortfolioPage;
